import type { AdminAuditEvent } from '../../../shared-types/src/index.js';

export function latestAuditId(events: AdminAuditEvent[]): string | undefined {
  return [...events].sort((a, b) => b.createdAt.localeCompare(a.createdAt))[0]
    ?.id;
}

export function findNewAuditId(
  before: AdminAuditEvent[],
  after: AdminAuditEvent[],
  expected: { eventType?: string; targetId?: string }
): string | undefined {
  const seen = new Set(before.map((event) => event.id));
  return after
    .filter((event) => !seen.has(event.id))
    .filter(
      (event) => !expected.eventType || event.eventType === expected.eventType
    )
    .filter(
      (event) => !expected.targetId || event.targetId === expected.targetId
    )
    .sort((a, b) => b.createdAt.localeCompare(a.createdAt))[0]?.id;
}
